import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'waiting-for-permission-splash-screen',
  templateUrl: './waiting-for-permission-splash-screen.component.html',
  styleUrls: ['./splash-screens.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WaitingForPermissionSplashScreenComponent {
}
